export const SETTINGS_STORAGE_KEY = 'digital-den:settings';
export const MEDIA_SETTINGS_STORAGE_KEY = 'digital-den:media-settings';
export const DAILY_URL_PREFIX = 'https://digital-den.daily.co/';
export const JOIN_ROOM_URL_PREFIX = 'https://digital-den.onrender.com';
export const JOIN_ROOM_URL_INFIX = '/room?roomId=';
export const DEFAULT_ROOM_ID= 'universal-hangout';
export const DEV_ROOM_ID= 'room-for-spatialization-demo';
